var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMegaphone = function SvgMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 3.1 5 7H1c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1l1.8 5.3c.1.4.5.7.9.7h.1c.6 0 1.1-.6 1-1.2L4 13h1l5.4 3.9a1 1 0 0 0 1.6-.8V12c1.1 0 2-.9 2-2s-.9-2-2-2V3.9c0-.8-.9-1.2-1.6-.8zM16 9c-.6 0-1 .4-1 1s.4 1 1 1h3c.6 0 1-.4 1-1s-.4-1-1-1h-3zM18.2 3.8c.4.4.4 1 0 1.4l-2 2c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l2-2c.4-.4 1-.4 1.4 0zM18.2 14.8c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-2-2c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l2 2z"
  })));
};
export default SvgMegaphone;